import { render, staticRenderFns } from "./page-agent-manage.vue?vue&type=template&id=0d831d5c&scoped=true&"
import script from "./page-agent-manage.vue?vue&type=script&lang=js&"
export * from "./page-agent-manage.vue?vue&type=script&lang=js&"
import style0 from "./page-agent-manage.vue?vue&type=style&index=0&id=0d831d5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d831d5c",
  null
  
)

export default component.exports